<script>
	import Steps from '../Steps';
	import StepTwo from './StepTwo';
	import StepThree from './StepThree';
	import StepFour from './StepFour';
	import StepFive from './StepFive';
	import swal from 'sweetalert';
	import { mapState,mapMutations } from 'vuex';
	import {stepSixTarget} from '../../stepsTargets.js';

	export default{
		components:{Steps,StepTwo,StepThree,StepFour,StepFive},
		data(){
			return{
				steps: stepSixTarget,
				buttonFinish:false,
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Terminar paso'
					}
				}
			}
		},
		computed:{
			...mapState(['stepActive','ejercicioActivo','alertas','calificacion','intentos','stepTwo','stepThree'])
		},
		mounted(){
			if(this.stepActive == 6 && this.alertas){
				this.$tours['stepSix'].start();
			}

			if(this.stepTwo.validoHastaFecha != '' &&
				this.stepTwo.tipoDeLocacion != '' &&
				this.stepTwo.numeroSAP != '' &&
				this.stepTwo.pagadorSAP != '' &&

				this.stepThree.tipoDeAportacion != '' &&
				this.stepThree.baseDeCalculo != '' &&
				this.stepThree.jerarquias.departamento != '' &&
				this.stepThree.tarifa != '' &&
				this.stepThree.baseArticulo != '' &&
				this.stepThree.niveles != '' &&
				this.stepThree.tipoDeTarifaNivel != '' &&
				this.stepThree.formato != '' &&
				this.stepThree.tipoDeDistribucion != ''
				){

				if(this.ejercicioActivo == 'ejercicio-1' || this.ejercicioActivo == 'ejercicio-4'){
					if(this.stepThree.jerarquias.subclase != ''){
						this.buttonFinish = true;
					}
				}else if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-3'){
					this.buttonFinish = true;
				}
				
				if(this.ejercicioActivo == 'evaluacion-1' || this.ejercicioActivo == 'evaluacion-2'){
					this.buttonFinish = true;	
				}
			}
		},
		methods:{
			...mapMutations(['changeStepActive','resetEmulador','noAlerts','saveEvaluacion','calculateResult','otherIntent','resetHARD']),
			terminated(){
				
				if(this.ejercicioActivo == 'ejercicio-1' || this.ejercicioActivo == 'ejercicio-3'){
					swal({
						title: `Ejercicio 1 completado`,
						text: `Haz clic en Aceptar para continuar el ejercicio 2.`,
						icon: "success",
						button: 'Aceptar'
					})
					.then((willDelete) => {
						if (willDelete) {
							this.resetEmulador();
						}
					});
				}

				if(this.ejercicioActivo == 'ejercicio-2' || this.ejercicioActivo == 'ejercicio-4'){
					swal({
						title: `Ejercicio 2 completado`,
						text: `Haz clic en Aceptar para continuar con el ejercicio de evaluación.`,
						icon: "success",
						button: 'Aceptar'
					})
					.then((willDelete) => {
						if (willDelete) {
							this.resetEmulador();
							this.noAlerts();
						}
					});
				}

				if(this.ejercicioActivo == 'evaluacion-1' || this.ejercicioActivo == 'evaluacion-2'){
					this.calculateResult();
					let title = this.calificacion >= 80 ? 'Aprobado':'Repropado';
					let text = this.calificacion >= 80 ? `Tu calificación fue del: ${this.calificacion.toFixed(2)} %.\nHaz concluido el curso correctamente.`:`Tu calificación fue del: ${this.calificacion.toFixed(2)} %.\nDa click en aceptar para volver a intentarlo`;
					let icon = this.calificacion >= 80 ? 'success':'error';

					swal({
						title,
						text,
						icon,
						button: 'Aceptar'
					})
					.then((willDelete) => {
						if (willDelete) {
							if(this.calificacion >= 80){
								this.resetHARD();
								localStorage.removeItem(window.keyAMS);
								window.pipwerks.SCORM.set("cmi.core.lesson_status", "completed");
								window.pipwerks.SCORM.set("cmi.core.score.raw", this.calificacion.toFixed(2));
								window.pipwerks.SCORM.quit();
								this.$router.push({ name: 'login' });
							}else{
								if(this.intentos == 0){
									this.otherIntent();
								}else{
									this.resetHARD();
									this.$router.push({ name: 'login' });
								}
							}
							
						}
					});
				}
			},
			restartTour(){
				this.$tours['stepSix'].start();
			}
		}
	}
</script>
<template>
	<div class="contenido">
		<v-tour name="stepSix" :steps="steps" :options="myOptions"/>
		<div class="header-tools">
			<div class="title">
				Crear Solicitud Acuerdo: Paso 6 (Revisar y Aprobar)
			</div>
			<div class="buttons">
				<div>
					<button @click="changeStepActive(stepActive-1)"> <i class="fas fa-chevron-left"></i> Atrás </button>
					<button disabled="">Continuar <i class="fas fa-chevron-right"></i></button>
					<span class="separator-buttons">|</span>
					<button> Edit </button>
					<button> Delete </button>
					<button :disabled="!buttonFinish" @click="terminated()" data-v-step="42"> Terminar ejercicio </button>
					| <button v-if="alertas" @click="restartTour()" class="btn-icon"><i class="fas fa-question-circle"></i> Instrucciones</button>
				</div>
			</div>
		</div>
		<steps :stepActive="stepActive"/>
		<hr class="separator-steps-content">
		
		<div class="container">
			<div class="row">
				<div class="col-md-6 ml-10">
					<p class="fz-13">Solicitud Acuerdo: V000415010</p>
					<div class="buttons">
						<button data-v-step="49"><i class="fas fa-user-check"></i> Enviar para aprobación</button>
						<button><i class="fas fa-file"></i> Crear Nueva Solicitud Acuerdo</button>
					</div>
				</div>
			</div>
			<step-two :reviewApprove="true"/>
			<step-three :reviewApprove="true"/>
			<step-four :reviewApprove="true"/>
			<step-five :reviewApprove="true"/>
		</div>
	</div>
</template>